<template lang="html">
  <div>
    <template>
      <div>
        <div class="vx-card nexteventheader_div">
          <div class="vx-card__header">
            <div class="vx-card__title">
              <p class="">Manage Agenda
                <feather-icon 
                  icon="DownloadCloudIcon" 
                  svgClasses="w-5 h-5 hover:text-danger stroke-current" 
                  class="ml-5" 
                  title="Export Agenda List"
                  @click="activePrompt=true"
                />
              </p>
            </div>
            <vs-button style="float:right;  " @click="$router.push({ path: '/admin/dashboard' })">Back</vs-button>
          </div>
        </div>
      </div>

      <vs-prompt title="Export To Excel" class="export-options" @cancle="clearFields" @accept="exportToExcel" accept-text="Export" @close="clearFields" :active.sync="activePrompt">
        <vs-input v-model="fileName" placeholder="Enter File Name.." class="w-full" />
        <v-select v-model="selectedFormat" :options="formats" class="my-4" />
        <div class="flex">
          <span class="mr-4">Cell Auto Width:</span>
          <vs-switch v-model="cellAutoWidth">Cell Auto Width</vs-switch>
        </div>
      </vs-prompt>
    
      <vx-card code-toggler>
        <vs-tabs>
          <vs-tab label="All Agendas" icon-pack="feather" icon="icon-box">
            <div class="tab-text">
              <vs-table max-items="10" pagination :data="agendas">
              <template slot="thead">
                <vs-th>Agenda Name</vs-th>
                <vs-th>Agenda Title</vs-th>
                <vs-th>Agenda Description</vs-th>
                <vs-th>Agenda Attachment</vs-th>
                <vs-th v-if='$store.getters.isRealAdmin'>Action</vs-th>
              </template>
              <template slot-scope="{data}">
                  <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                    <vs-td :data="data[indextr].name">{{ data[indextr].name }}</vs-td>
                    <vs-td :data="data[indextr].title">{{ data[indextr].title }}</vs-td>
                    <vs-td :data="data[indextr].description">{{ data[indextr].description }}</vs-td>
                    <vs-td v-if="data[indextr].attachments && data[indextr].attachments.length > 0">
                      <div v-for="(bulk, bindex) in data[indextr].attachments" :key="bindex">
                        <div v-if="bulk.attachment != null && bulk.attachment != ''">
                          <a :href="bulk.path" type="download" target="_blank">{{ bulk.attachment }}</a>
                          <feather-icon icon="XCircleIcon" @click="deleteAttachment(data[indextr].id, bulk.attachment, data[indextr].attachments)" svgClasses="w-5 h-5 hover:text-danger stroke-current" class="ml-2" style="vertical-align: sub;" />
                        </div>
                        <div v-else>
                          <span>NA</span>
                        </div>
                      </div>
                    </vs-td>
                    <vs-td :data="data[indextr].id" v-else>NA</vs-td>
                    <vs-td :data="data[indextr].id" v-if='$store.getters.isRealAdmin'>
                      <feather-icon icon="TrashIcon" 
                        svgClasses="w-5 h-5 hover:text-danger stroke-current" 
                        class="ml-2" 
                        @click="deleteAgenda(data[indextr].id)"
                      />
                    </vs-td>
                  </vs-tr>
              </template>
            </vs-table>
            </div>
          </vs-tab>
          <vs-tab v-if='$store.getters.isRealAdmin' label="Add Agenda" icon-pack="feather" icon="icon-mail">
              <div class="tab-text">
                <form @submit.prevent="handleSubmit">
                  <div class="vx-row">
                    <div class="vx-col md:w-full w-full mt-5">
                      <label>Title:</label>
                      <vs-input
                        v-model="agenda.title"
                        class="w-full"
                        name="title"
                        v-validate="'required'"
                      />
                      <span class="text-danger">{{ errors.first('title') }}</span>
                    </div>
                  </div>
                  <div class="vx-row">
                    <div class="vx-col md:w-full w-full mt-5">
                      <label>Name:</label>
                      <vs-input
                        v-model="agenda.name"
                        class="w-full"
                        name="name"
                        v-validate="'required'"
                      />
                      <span class="text-danger">{{ errors.first('name') }}</span>
                    </div>
                  </div>
                  <div class="vx-row">
                    <div class="vx-col md:w-full w-full mt-5">
                      <label>Description:</label>
                      <vs-input
                        v-model="agenda.description"
                        class="w-full"
                        name="description"
                        v-validate="'required'"
                      />
                      <span class="text-danger">{{ errors.first('description') }}</span>
                    </div>
                  </div>
                  <div class="vx-row">
                    <div class="vx-col md:w-full w-full mt-5">
                      <label >Attachment:</label>
                      <br />
                      <label>
                        <input style="margin-top: 20px;" type="file" id="file" ref="file" name="file[]" multiple v-on:change="handleFileUpload()"/>
                      </label>
                    </div>
                  </div>
                   <vs-button style="margin-top: 30px;" @click="handleSubmit">Save</vs-button>
               </form>
              </div>
          </vs-tab>
          <vs-tab v-if='$store.getters.isRealAdmin' label="Edit Agenda" icon-pack="feather" icon="icon-mail">
            <div class="tab-text">
              <div class="vx-row">
                <div class="vx-col md:w-1/2 w-full mt-5">
                    <label>Select agenda to update:</label>
                    <vs-select v-model="agendaSelected" 
                    class="w-full select-large"
                    @input="onAgendaSelected()" :disabled="agendaSelectDisabled">
                      <vs-select-item
                        :key="index"
                        :value="item.id"
                        :text="item.name"
                        v-for="(item,index) in agendas"
                        class="w-full"
                      />
                    </vs-select>
                </div>
                <div class="vx-col md:w-1/2 w-full mt-10">
                    <vs-button @click="resetEditForm()" class="attendBtn">Clear</vs-button>
                </div>
              </div>
              <div class="eventSmsEmailBlock" v-if="showAgendaBlock == true">
                 <div class="vx-row">
                    <div class="vx-col md:w-full w-full mt-5">
                      <label>Title:</label>
                      <vs-input
                        v-model="agendaTitle"
                        class="w-full"
                        name="agendaTitle"
                        v-validate="'required'"
                      />
                      <span class="text-danger">{{ errors.first('agendaTitle') }}</span>
                    </div>
                  </div>
                  <div class="vx-row">
                    <div class="vx-col md:w-full w-full mt-5">
                      <label>Name:</label>
                      <vs-input
                        v-model="agendaName"
                        class="w-full"
                        name="agendaName"
                        v-validate="'required'"
                      />
                      <span class="text-danger">{{ errors.first('agendaName') }}</span>
                    </div>
                  </div>
                  <div class="vx-row">
                    <div class="vx-col md:w-full w-full mt-5">
                      <label>Description:</label>
                      <vs-input
                        v-model="agendaDescription"
                        class="w-full"
                        name="agendaDescription"
                        v-validate="'required'"
                      />
                      <span class="text-danger">{{ errors.first('agendaDescription') }}</span>
                    </div>
                  </div>
                  <div class="vx-row">
                    <div class="vx-col md:w-full w-full mt-5">
                      <label >Attachment: 
                        <div v-if="attachMultiple && attachMultiple.length > 0">
                          <div v-for="(attachmulti, mindex) in attachMultiple" :key="mindex">
                            <div v-if="attachmulti.attachment">
                              <a :href="attachmulti.path" type="download" target="_blank">{{ attachmulti.attachment }}</a>
                              <feather-icon icon="XCircleIcon" @click="deleteAttachment(agendaAttachId, attachmulti.attachment, attachMultiple)" svgClasses="w-5 h-5 hover:text-danger stroke-current" class="ml-2" style="vertical-align: sub;" />
                            </div>
                          </div>
                        </div>
                      </label>
                      <br />
                      <label>
                        <input style="margin-top: 20px;" type="file" id="file" ref="file" multiple v-on:change="updateAttachment()"/>
                      </label>
                    </div>
                  </div>
                  <div class="vx-col md:w-1/2 w-full mt-10">
                    <vs-button @click="updateAgenda()" class="updateConfigBtn">Save</vs-button>
                  </div>
              </div>
            </div>
          </vs-tab>
        </vs-tabs>
      </vx-card>
    </template>
  </div>
</template>

<script>
import vSelect from 'vue-select'
import $ from "jquery";
import { Validator } from "vee-validate";
export default {
  components: {
    vSelect
  },
  data: () => ({
    activePrompt: false,
    fileName: '',
    // formats:['xlsx', 'csv', 'txt'],
    formats:['xlsx'],
    cellAutoWidth: true,
    selectedFormat: 'xlsx',
    headerTitle: ['Agenda Name', 'Agenda Title', 'Agenda Description'],
    headerVal: ['name', 'title', 'description'],

    file: [],
    updatedfile: '',
    agenda: {
      event_id: '',
      title: '',
      name: '',
      description: '',
      attachment: ''
    },
    agendas: [{}],
    submitted: false,
    agendaSelected: '',
    showAgendaBlock: false,
    agendaTitle: '',
    agendaName: '',
    agendaDescription: '',
    showattachment: '',
    agendaSelectDisabled: false,
    showattachmentname: '',
    attachmentbulk: [],
    attachMultiple: [],
    agendaAttachId: ''
  }),
  created() {
      this.agenda.event_id = this.$route.params.id;
  },
  mounted() {
    this.GetAgendaList();
  },
  methods: { 
    deleteAttachment(agendid, attachmentName, attachmentList){
      this.$swal({
        title: "Are you sure to delete the attachment?",
        text: "You can't revert your action",
        type: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes",
        confirmButtonColor: "#7367F0",
        cancelButtonText: "No",
        showCloseButton: true,
        showLoaderOnConfirm: true
      }).then(result => {
        if (result.value) {
          attachmentList.forEach((attach, index) => {
            if(attach.attachment == attachmentName){
              attachmentList.splice(index, 1);
            }
          })
          let data = {"id": agendid, "deleted_attachment": attachmentName, "attachments": attachmentList}
          this.$vs.loading();
          this.$store
            .dispatch("DeleteEventAgendaFile",data)
            .then(response => {
              this.$vs.loading.close();
              this.$vs.notify({
                title: "Success",
                text: "Attachment deleted successfully",
                color: "success",
                position: "top-center"
              });
              // location.reload();
            })
            .catch(error => {
              this.$vs.loading.close();
              // Error response
              this.$vs.notify({
                title: "Failed to delete Attachment",
                text: error,
                color: "danger",
                position: "top-center"
              });
            return false;
            });
        }
      })
    },
    deleteAgenda(id) {
      this.$swal({
        title: "Are you sure to delete the agenda?",
        text: "You can't revert your action",
        type: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes",
        confirmButtonColor: "#7367F0",
        cancelButtonText: "No",
        showCloseButton: true,
        showLoaderOnConfirm: true
      }).then(result => {
        if (result.value) {
          this.$vs.loading();
          this.$store
            .dispatch("DeleteEventAgenda",id)
            .then(response => {
              this.GetAgendaList();
              this.$vs.loading.close();
              this.$vs.notify({
                title: "Success",
                text: "Agenda deleted successfully",
                color: "success",
                position: "top-center"
              });
            })
            .catch(error => {
              this.$vs.loading.close();
              // Error response
              this.$vs.notify({
                title: "Failed to load data",
                text: error,
                color: "danger",
                position: "top-center"
              });
            return false;
            });
        }
      })
    },
    resetEditForm() {
      this.agendaSelectDisabled = false;
      this.agendaSelected = '';
      this.showAgendaBlock = false;
    },
    updateAgenda(){
      this.$validator.validate().then(valid => {
        if (valid) {
          let formData = new FormData();
          formData.append('id', this.agendaSelected);
          formData.append('event_id', this.agenda.event_id);
          formData.append('name', this.agendaName);
          formData.append('title', this.agendaTitle);
          formData.append('description', this.agendaDescription);
          // formData.append('attachment', this.updatedfile);
          if(this.updatedfile != ''){
            var filesLength = this.updatedfile.files.length;
            for(var i=0;i<filesLength;i++){
              formData.append("attachment[]", this.updatedfile.files[i]);
            }
          } else {
            formData.append("attachment[]", '');
          }
          
          this.$store
          .dispatch("UpdateAgenda", formData)
          .then(response => {
            this.GetAgendaList();
              this.$vs.loading.close();
              this.$vs.notify({
                  title: "Success",
                  text: "Agenda updated successfully!",
                  color: "success",
                  position: "top-center"
              });
              location.reload();
          })
          .catch(error => {
              this.$vs.loading.close();
              // Error response
              this.$vs.notify({
                  title: "Could not add agenda.",
                  text: error,
                  color: "danger",
                  position: "top-center"
              });
              return false;
          });
        } else {
            this.$vs.notify({
              title: "Form submit failed",
              text: "Please enter required fields",
              color: "danger",
              position: "top-center"
            });
        }
      });

    },
    onAgendaSelected(){
      this.showAgendaBlock = true;
       this.agendaSelectDisabled = true;
      this.agendas.forEach((agenda, index) => {
        if(agenda.id == this.agendaSelected){
          this.agendaAttachId = agenda.id;
          this.agendaTitle = agenda.title;
          this.agendaName = agenda.name;
          this.agendaDescription = agenda.description;
          this.showattachment = agenda.attachment_path;
          this.showattachmentname = agenda.attachment;
          this.attachMultiple = agenda.attachments;
        }
      })
    },
    GetAgendaList() {
      this.$vs.loading();
      this.$store
        .dispatch("GetAgendaList",this.agenda.event_id)
        .then(response => {
          this.$vs.loading.close();
          this.agendas = response.data.data;
        })
        .catch(error => {
          this.$vs.loading.close();
          // Error response
          this.$vs.notify({
            title: "Failed to load data",
            text: error,
            color: "danger",
            position: "top-center"
          });
          return false;
        });
    },
    handleSubmit(e) {
        this.submitted = true;
        this.$validator.validate().then(valid => {
            if (valid) {
              this.agenda.attachment = this.file;
              let formData = new FormData();
              formData.append('event_id', this.agenda.event_id);
              formData.append('title', this.agenda.title);
              formData.append('name', this.agenda.name);
              formData.append('description', this.agenda.description);
              // formData.append('attachment', this.file);
              if(this.file != ''){
                var filesLength = this.file.files.length;
                for(var i=0;i<filesLength;i++){
                  formData.append("attachment[]", this.file.files[i]);
                }
              }

              this.$store
                .dispatch("AddAgenda", formData)
                .then(response => {
                    this.$vs.loading.close();
                    this.$vs.notify({
                        title: "Success",
                        text: "Agenda added successfully!",
                        color: "success",
                        position: "top-center"
                    });
                    location.reload();
                })
                .catch(error => {
                    this.$vs.loading.close();
                    // Error response
                    this.$vs.notify({
                        title: "Could not add agenda.",
                        text: error,
                        color: "danger",
                        position: "top-center"
                    });
                    return false;
                });
            }  else {
                this.$vs.notify({
                  title: "Form submit failed",
                  text: "Please enter required fields",
                  color: "danger",
                  position: "top-center"
                });
            }
        });
    },
    handleFileUpload(){
      if(this.$refs.file.files.length > 5){
        this.$vs.notify({
            title: "File upload limit",
            text: "Maximum 5 files can be uploaded",
            color: "danger",
            position: "top-center"
        });
        this.file = '';
        $("#file").val('');
      } else {
        let validFiles = 1;
        this.$refs.file.files.forEach((filevalue, index) => {
          var filePath = filevalue.name;
          var allowedExtensions = /(\.doc|\.docx|\.pdf|\.xls|\.xlsx|\.ppt|\.pptx|\.jpg|\.jpeg|\.png|\.gif)$/i;
          if(!allowedExtensions.exec(filePath)){
            validFiles = 0;
          }
        })
        if(validFiles == 0 ) {
         this.$vs.notify({
            title: "File upload",
            text: "Please upload file having extensions .doc .docx, .pdf, .xls .xlsx .ppt .pptx .jpeg .jpg .png .gif only.",
            color: "danger",
            position: "top-center"
          });
          this.file = '';
          $("#file").val('');
        } else {  
          this.file = this.$refs.file;
        }
      }
    },
    updateAttachment(){
      if(this.$refs.file.files.length > 5){
        this.$vs.notify({
            title: "File upload limit",
            text: "Maximum 5 files can be uploaded",
            color: "danger",
            position: "top-center"
        });
        this.updatedfile = '';
        $("#file").val('');
      } else {
        let validFiles = 1;
        this.$refs.file.files.forEach((filevalue, index) => {
          var filePath = filevalue.name;
          var allowedExtensions = /(\.doc|\.docx|\.pdf|\.xls|\.xlsx|\.ppt|\.pptx|\.jpg|\.jpeg|\.png|\.gif)$/i;
          if(!allowedExtensions.exec(filePath)){
            validFiles = 0;
          }
        })
        if(validFiles == 0 ) {
         this.$vs.notify({
            title: "File upload",
            text: "Please upload file having extensions .doc .docx, .pdf, .xls .xlsx .ppt .pptx .jpeg .jpg .png .gif only.",
            color: "danger",
            position: "top-center"
          });
          this.updatedfile = '';
          $("#file").val('');
        } else {
          this.updatedfile = this.$refs.file;
        }
      }
    },
    exportToExcel () {
      import('@/utils/Export2Excel').then(excel => {
        const list = this.agendas
        const data = this.formatJson(this.headerVal, list)
        excel.export_json_to_excel({
          header: this.headerTitle,
          data,
          filename: this.fileName,
          autoWidth: this.cellAutoWidth,
          bookType: this.selectedFormat
        })
        this.clearFields()
      })
    },
    formatJson (filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => {
        return v[j]
      }))
    },
    clearFields () {
      this.filename = ''
      this.cellAutoWidth = true
      this.selectedFormat = 'xlsx'
    }
  },
}
</script>
<style lang="scss">
  .vx-card__actions{
    display: none;
  }
  .vx-card{
    box-shadow: 0px 25px 25px 0px rgba(0, 0, 0, 0.1) !important;
    border-radius: 0 !important;
  }
  .updateConfigBtn{
    padding: 0.70rem 1.5rem !important;
    margin: 4px !important;
  }
  .eventSmsEmailBlock{
    margin-top: 30px;
  }
  .eventSmsEmailBlock input{
    margin-bottom: 20px;
  }
</style>